import React from "react";
import UF_Content from "../../../../nix_components/components/UF_Content";
import data_types from "../../../../nix_components/data/data_types";

class Nominations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permission: "award",
      scopeCondition: false,
    };
  }

  buttons = {};

  formConfig = {
    rows: [
      [
        "name",
        {
          label: "Category",
          datatype: data_types.reference,
          reference: "categories",
          field: "category_id",
        },
      ],
      [
        {
          label: "Ordering",
          datatype: data_types.number,
          reference: "categories",
          field: "ordering",
        },
      ],
      [
        {
          label: "Description",
          multiline: true,
          datatype: data_types.string,
          field: "description",
        },
      ],
      [
        {
          label: "Logo",
          field: "logo_path",
          datatype: data_types.file,
        },
        {},
      ],
    ],
  };

  gridProps = {
    fields: [
      "name",
      "category_id",
      "ordering",
      "description",
      "winner_id",
      "created_at",
    ],
  };

  handleBeforeAddNew = (dataItem, callback) => {
    dataItem.award_id = global.UF.award_id;
    if (callback) {
      callback();
    }
  };

  findCurrentPermission = () => {
    const user =
      typeof localStorage.getItem("user") === "string"
        ? JSON.parse(localStorage.getItem("user"))
        : localStorage.getItem("user");
    const scopes = user.hasOwnProperty("scopes")
      ? typeof user.scopes === "string"
        ? JSON.parse(user.scopes)
        : user.scopes
      : null;
    this.state.scopeCondition =
      scopes.findIndex(
        (permission) =>
          permission.split(":")[0] === this.state.permission &&
          permission.includes("write")
      ) > -1;
    this.setState({ loaded: true });
  };

  componentDidMount() {
    this.findCurrentPermission();
  }

  render() {
    return (
      <UF_Content
        table="nominations"
        title="Nominations"
        id={this.props.award_id}
        buttons={this.buttons}
        gridProps={this.gridProps}
        edit={this.state.scopeCondition}
        export={this.state.scopeCondition}
        delete={this.state.scopeCondition}
        add={this.state.scopeCondition}
        sync={this.state.scopeCondition}
        beforeAddNew={this.handleBeforeAddNew}
        permission="award"
        formConfig={this.formConfig}
      />
    );
  }
}

export default Nominations;
